import { LuLayoutGrid } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import fullLogo from "../../../assets/logo_completo.png";
import { setIsDesktop, toggleCollapsed } from '../../../redux/sidebarSlice';
import { AppDispatch, RootState } from '../../../redux/store';
import cn from '../../../utils/classNames';
import { SidebarMenu } from "./sidebar-menu";
import { useEffect } from 'react';

interface SidebarProps {
	className?: string;
	closeDrawer?: Function;
	tutor?: boolean;
	collapsed?: boolean;
	onToggleCollapse?: () => void;
}

export default function Sidebar({ className, closeDrawer, tutor }: SidebarProps) {

	const dispatch = useDispatch<AppDispatch>();
	const { collapsed, hoverCollapsed, isDesktop } = useSelector((state: RootState) => state.sidebarSlice);

	// Create listener to update isDesktop state
	useEffect(() => {
		const handleResize = () => {
			dispatch(setIsDesktop(window.innerWidth >= 1280));
		};

		window.addEventListener('resize', handleResize);
		handleResize();

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	

	return (
		<aside
			className={cn(
				"fixed bottom-0 start-0 z-[200] h-full border-r-2 border-gray-100 bg-white dark:bg-gray-100/50 transition-all duration-300",
				isDesktop && collapsed && !hoverCollapsed ? "w-[80px] 2xl:w-[80px]" : "w-[270px] 2xl:w-72",
				className
			)}
		>
			<div className="sticky top-0 z-40 bg-gray-0/10 px-2 pb-5 pt-5 dark:bg-gray-100/5 2xl:px-4 2xl:pt-6 flex justify-between items-center">
				{!collapsed || hoverCollapsed || !isDesktop ?
					<Link
						to={'/'}
						aria-label="Site Logo"
						className="text-gray-800 hover:text-gray-900"
					>
						<img src={fullLogo} width={'150px'} alt="Logo de Gema" />
					</Link>
					:<></>
				}
				{isDesktop && (
					<button
						aria-label={collapsed && !hoverCollapsed ? "Expandir sidebar" : "Colapsar sidebar"}
						onClick={() => isDesktop && dispatch(toggleCollapsed())}
						className={cn("p-1 rounded hover:bg-gray-200 transition-colors", collapsed && !hoverCollapsed ? "m-auto" : "mr-2")}
					>
						<LuLayoutGrid className='text-gray-800' size={24} />
					</button>
				)}
			</div>
			<SimpleBar className="h-[calc(100%-80px)]">
				<SidebarMenu closeDrawer={closeDrawer} />
			</SimpleBar>
		</aside>
	);
}